// Registers the service worker that powers the installable-app (PWA) basics:
// offline fallback page now, the hook push notifications will need later.
// The worker file lives in public/sw.js (root scope, outside Vite) — a SW can
// only control paths at or below its own URL, so it must be served from /.
// Registration is idempotent, so the Turbolinks double-init concern that
// applies to listeners elsewhere doesn't apply here.
if ('serviceWorker' in navigator) {
  window.addEventListener('load', function () {
    navigator.serviceWorker.register('/sw.js').catch(function () {
      // Progressive enhancement only — the app works fine without it.
    })
  })
}
